import { FilterSettingsModel, IFilter, PageSettingsModel, SelectionSettingsModel } from '@syncfusion/ej2-react-grids';

export const getSettingsSort = (navData) => {

  const selectionSettings: SelectionSettingsModel = {
    type: 'Multiple'
  };
  const pageSettingsInfinite: PageSettingsModel = {
    pageSize: 100
  };
  const filterMenu: IFilter = {
    type: 'CheckBox',
    operator: 'contains'
  };
  const pageSettings: PageSettingsModel = {
    pageSize: navData?.widgetData?.pageSize ?? '20',
    pageSizes: ['5', '10', '20', '50']
  };
  const customAttributes: any = { class: 'customcss' };
  const filterSettingsMenu: FilterSettingsModel = {
    showFilterBarOperator: true,
    mode: 'Immediate',
    immediateModeDelay: 400
  };
  const rowDropSettings: object = navData.widgetData.dependency !== null ? { targetID: `grid-${navData.widgetData.dependency?.target?.id}` } : null;

  return {
    pageSettingsInfinite,
    filterMenu,
    pageSettings,
    customAttributes,
    selectionSettings,
    filterSettingsMenu,
    rowDropSettings
  };
};